<template>
  <router-link
    v-if="quebradas.length > 0"
    class="router"
    :to="destino"
  >
    <div class="aviso-cargas">
      <fa-icon icon="exclamation-triangle" class="aviso-cargas__icone" />
      <p v-if="quebradas.length === 1">
        A carga de dados ativa <strong>{{ quebradas[0].tarefa }}</strong> está com falha.
        Clique para ver os detalhes.
      </p>
      <p v-else>
        <strong>{{ quebradas.length }} cargas de dados ativas</strong> estão com falhas.
        Clique para ver todas.
      </p>
    </div>
  </router-link>
</template>

<script>
import { get } from '@/helpers/apiRequest';
import { moduloAutorizado } from '@/helpers/cargas';
import { statusOf } from '@/helpers/cargasSaude';

export default {
  name: 'AvisoCargasQuebradas',
  data() {
    return {
      quebradas: [],
    };
  },
  computed: {
    destino() {
      // sempre abre a aba de cargas já filtrada por "Com falha"; com 1 quebrada,
      // também pré-preenche a busca pelo nome da tarefa
      if (this.quebradas.length === 1) {
        return `/configuracoes/cargas?status=quebradas&q=${encodeURIComponent(this.quebradas[0].tarefa)}`;
      }
      return '/configuracoes/cargas?status=quebradas';
    },
  },
  methods: {
    carregarCargas() {
      get('/admin/tarefas')
        .then((tarefas) => {
          this.quebradas = (tarefas || []).filter((t) => statusOf(t) === 'quebrada');
        })
        .catch(() => {
          this.quebradas = [];
        });
    },
  },
  beforeMount() {
    // Só consulta/exibe se o usuário tiver permissão de acessar a tela de Cargas
    if (moduloAutorizado('ADMIN_CARGA_DADOS')) {
      this.carregarCargas();
    }
  },
};
</script>

<style scoped>
.router {
  width: 100%;
  display: flex;
  justify-content: center;
  text-decoration: none;
  margin-bottom: 25px;
}

.aviso-cargas {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 19px;
  color: #8c2a20;
  background-color: #fdeaea;
  border-left: 4px solid #c0392b;
  border-radius: 5px;
  font-size: larger;
}

.aviso-cargas:hover {
  background-color: #f9dcd9;
}

.aviso-cargas__icone {
  color: #c0392b;
  flex-shrink: 0;
}

.aviso-cargas p {
  margin-bottom: 0;
}
</style>
